function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
/**
 * Double Box Adapter converts NonLinearAvails into Regular DAI ads using adapter pattern
 * Step by step algorithm
 * 1. Retrieve DoubleBox NonLinearAvails from the rest by identifying nonLinearAd.staticResourceCreativeType === 'null/null'
 * 2. Convert Double Box NonLinearAvails to DAI ad breaks using parser callback
 * 3. Combine regular DAI with new double box DAI and filter out duplicates, while favouring the double box ads.
 * Sometimes regular DAI may have same startPosition as doubleBox DAI, but these regular DAI are empty so they are safe to remove
 */ export var DoubleBoxToAdBreaksAdapter = /*#__PURE__*/ function() {
    "use strict";
    function DoubleBoxToAdBreaksAdapter() {
        _class_call_check(this, DoubleBoxToAdBreaksAdapter);
    }
    _create_class(DoubleBoxToAdBreaksAdapter, null, [
        {
            key: "adapt",
            value: function adapt(adBreaks, doubleBoxAds, parseAdBreakData, isCsai, adServerCdn) {
                var doubleBoxAdBreaks = DoubleBoxToAdBreaksAdapter.convertDoubleBoxIntoDaiAdBreaks(doubleBoxAds, parseAdBreakData, isCsai, adServerCdn);
                var combinedAdBreaks = adBreaks.filter(function(adBreak) {
                    // For DAI Ad Breaks which ID is the same as nonLinearAvails Id.
                    // DAI Ad Breaks have ads = [], so they can be filtered out. Their complementary from nonLinearAvails contains ads when converted to DAI so the ad break is preserved
                    // And duplicated is filtered out
                    var isDuplicated = Boolean(doubleBoxAdBreaks.find(function(convertedDaiAdBreak) {
                        var convertedDaiAdBreakId = convertedDaiAdBreak.id;
                        if (convertedDaiAdBreakId.includes('_')) {
                            // Format like: 705534_PT764H51M50.0103622S -> 705534s
                            convertedDaiAdBreakId = convertedDaiAdBreakId.slice(0, convertedDaiAdBreakId.lastIndexOf('_'));
                        }
                        var adBreakId = adBreak.id;
                        if (adBreakId.includes('_')) {
                            // Format like: 705534_PT764H51M50.0103622S -> 705534
                            adBreakId = adBreakId.slice(0, adBreakId.lastIndexOf('_'));
                        }
                        return convertedDaiAdBreakId === adBreakId;
                    }));
                    return !isDuplicated;
                }).concat(doubleBoxAdBreaks);
                return combinedAdBreaks;
            }
        },
        {
            key: "splitDoubleBoxFromNonLinearAvails",
            value: function splitDoubleBoxFromNonLinearAvails(nonLinearAvails) {
                return nonLinearAvails.reduce(function(acc, nonLinearAvail) {
                    var isDoubleBoxAd = nonLinearAvail.nonLinearAdsList.some(function(nonLinearAds) {
                        return nonLinearAds.nonLinearAdList.some(function(nonLinearAd) {
                            return nonLinearAd.staticResourceCreativeType === 'null/null';
                        });
                    });
                    if (isDoubleBoxAd) {
                        acc.doubleBoxAds.push(nonLinearAvail);
                    } else {
                        acc.nonLinearAds.push(nonLinearAvail);
                    }
                    return acc;
                }, {
                    doubleBoxAds: [],
                    nonLinearAds: []
                });
            }
        },
        {
            key: "convertDoubleBoxIntoDaiAdBreaks",
            value: function convertDoubleBoxIntoDaiAdBreaks(nonLinearAvails, parseAdBreakData, isCsai, adServerCdn) {
                var adBreaks = nonLinearAvails.map(function(nonLinearAvail) {
                    var rawAdBreak = _object_spread_props(_object_spread({}, nonLinearAvail), {
                        ads: nonLinearAvail.nonLinearAdsList
                    });
                    return parseAdBreakData(rawAdBreak, isCsai, adServerCdn);
                });
                return adBreaks;
            }
        }
    ]);
    return DoubleBoxToAdBreaksAdapter;
}();

//# sourceMappingURL=double-box-to-ad-breaks-adapter.js.map